import axios from "axios";
import { apiEndpoint } from '@iso/lib/helpers/endpoint';

export const propertyCheckinService = {
  getLanding,
  getForm,
  getContractorStatus,
  contractorCheckout,
  divisionContactFailed,
  divisionContactConfirmed,
  getDivisionContact,
  confirmDivisionContact,
};

function getLanding(token) {
  return axios
    .get(`${apiEndpoint.propertyCheckin}/landing`, {
      params: { token },
    })
    .then((res) => {
      if (res && res.status === 200) {
        return res.data;
      }
    });
}

function getForm(token, role) {
  return axios
    .get(`${apiEndpoint.propertyCheckin}/form`, {
      params: { token, role },
    })
    .then((res) => {
      if (res && res.status === 200) {
        return res.data;
      }
    });
}

// Is a browser-remembered contractor check-in still active on this property?
function getContractorStatus(token, checkoutToken) {
  return axios
    .get(`${apiEndpoint.propertyCheckin}/contractor-status`, {
      params: { token, checkout_token: checkoutToken },
    })
    .then((res) => {
      if (res && res.status === 200) {
        return res.data;
      }
    });
}

// Check out an active contractor check-in. coords = { latitude, longitude } (optional).
function contractorCheckout(token, checkoutToken, coords = {}) {
  return axios
    .post(`${apiEndpoint.propertyCheckin}/contractor-checkout`, {
      token,
      checkout_token: checkoutToken,
      latitude: coords.latitude,
      longitude: coords.longitude,
    })
    .then((res) => {
      if (res && res.status === 200) {
        return res.data;
      }
    });
}

// The contractor could not reach their division contact — alerts staff and
// returns the main office details to direct them to.
function divisionContactFailed(token, checkoutToken) {
  return axios
    .post(`${apiEndpoint.propertyCheckin}/division-contact-failed`, {
      token,
      checkout_token: checkoutToken,
    })
    .then((res) => {
      if (res && res.status === 200) {
        return res.data;
      }
    });
}

// The contractor says they have made contact with their division contact.
// Returns { code, division_contact } — the check-in is complete only once the
// contact confirms too.
function divisionContactConfirmed(token, checkoutToken) {
  return axios
    .post(`${apiEndpoint.propertyCheckin}/division-contact-confirmed`, {
      token,
      checkout_token: checkoutToken,
    })
    .then((res) => {
      if (res && res.status === 200) {
        return res.data;
      }
    });
}

// Division contact's side (public page opened from an SMS link).
function getDivisionContact(token) {
  return axios
    .get(`${apiEndpoint.divisionContact}/view`, {
      params: { token },
    })
    .then((res) => {
      if (res && res.status === 200) {
        return res.data;
      }
    });
}

function confirmDivisionContact(token) {
  return axios
    .post(`${apiEndpoint.divisionContact}/confirm`, { token })
    .then((res) => {
      if (res && res.status === 200) {
        return res.data;
      }
    });
}
